













import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class AddBranchEnd extends Vue {
    // ------ prop ------
    @Prop() childrenNodeP!: any
    @Prop() conditions!: any

    // ------ 生命周期 ------
    created() {
        // console.log(this.childrenNodeP);
        // console.log(this.conditions);
        // console.log('branch-end');
    }

    // ------ 方法 ------
    addnode(type: number) {
        // console.log(this.childrenNodeP);
        // console.log(this.conditions);
        if(type !== 3) {
            // console.log('添加节点');
            // 在添加节点的时候，不论在哪添加节点都需要拿到当前节点的 chidlren 和 conditions 然后将其赋值给新创建的子节点的 chidlren 和 conditions ，将新创建的节点作为”被添加节点的children"
            let data: any;
            if(type === 0) {
                data = {
                    nodeObject: this.childrenNodeP,
                    conditionList: this.conditions,
                    approvalType: '',
                    approvalPersonOrLevelType: '',
                    approvalPersonOrLevelRange: '',
                    userIdList: '',
                    approvalSettingType: '',
                    approvalSettingUserId: '',
                    infoNode: 0,
                    editFile: [],
                    types: '0'
                }
            } else if(type === 1) {
                data = {
                    nodeObject: this.childrenNodeP,
                    conditionList: this.conditions,
                    approvalType: '',
                    approvalPersonOrLevelType: '',
                    approvalPersonOrLevelRange: '',
                    userIdList: '',
                    approvalSettingType: '',
                    approvalSettingUserId: '',
                    infoNode: 0,
                    editFile: [],
                    types: '1'
                }
            }
            this.$emit("update:childrenNodeP", data)
            // this.$emit("update:conditions", [])
        } 
    }
}

